import { WORDS_CREDIT, qurancomUrl } from '@iqrapath/shared'
import { AudioButton } from '../../components/AudioButton.tsx'
import { Sheet } from '../../components/Sheet.tsx'
import { SourceLink } from '../../components/SourceLink.tsx'
import type { Word } from './ayat.ts'

/** One tappable word: verse `k`, position `i` of `n`, stable `id` ("k:i"). */
export type WordItem = { k: number; i: number; n: number; w: Word; id: string; isKey: boolean }

/** Meaning of a word in a sheet, with its sound and previous/next word (Fahami step and the Qur'an reader). */
export function WordSheet({ surah, items, at, onMove, onClose, note }: { surah: number; items: WordItem[]; at: number; onMove: (i: number) => void; onClose: () => void; note?: string | null }) {
  const it = items[at]!
  const { w } = it
  return (
    <Sheet title="Arti kata" onClose={onClose}>
      <p className="ar sheet-ar" lang="ar" dir="rtl">{w.ar}</p>
      {w.latin && <p className="lat" style={{ textAlign: 'center' }}>{w.latin}</p>}
      <p className="arti">{w.arti ?? 'Arti kata ini belum tersedia.'}</p>
      {w.audio && <div style={{ display: 'flex', justifyContent: 'center' }}><AudioButton id={`w-${it.id}`} srcs={[w.audio]} what="kata ini" /></div>}
      {it.isKey && (
        <div className="key-note">
          <span className="pill pill-amber">Kata kunci hari ini</span>
          {note && <p>{note}</p>}
        </div>
      )}
      <p className="help" style={{ textAlign: 'center' }}>Ayat {it.k} · kata ke-{it.i + 1} dari {it.n}</p>
      <div className="sheet-nav">
        <button type="button" className="btn btn-ghost btn-sm" disabled={at === 0} onClick={() => onMove(at - 1)}>Kata sebelumnya</button>
        <button type="button" className="btn btn-secondary btn-sm" disabled={at === items.length - 1} onClick={() => onMove(at + 1)}>Kata berikutnya</button>
      </div>
      <p className="credit" style={{ textAlign: 'center' }}><SourceLink href={qurancomUrl(surah, it.k)}>{WORDS_CREDIT}</SourceLink></p>
    </Sheet>
  )
}
